// extracted by mini-css-extract-plugin
export default {"hotspotsList":"index_hotspotsList_9EPAe","hotspotsItem":"index_hotspotsItem_4jlj0"};